import React, { useEffect, useState } from 'react'
import { tracingAxios } from '../../Repository/Sentry.js'
import { Environment } from '../../environment.js'
import type { VersionResponse } from '../../Generated/VersionResponse.js'
import { formatDate, parseDate } from '../../Util/DateHandling.ts'

export const BlastVersionsTab: React.FC = () => {
  const [versions, setVersions] = useState<VersionResponse | undefined>()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchVersions = async () => {
      try {
        const { data } = await tracingAxios.get<VersionResponse>(`${Environment.API_URL}/api/blast/version`, { withCredentials: true })
        setVersions(data)
      } catch (e) {
        console.error('Failed to fetch blast versions', e)
        setError('Failed to fetch blast versions')
      } finally {
        setIsLoading(false)
      }
    }

    fetchVersions()
  }, [])

  if (isLoading) {
    return <div className="p-10 text-center">Loading versions...</div>
  }

  if (error || !versions) {
    return <div className="p-10 text-center text-red-500">{error}</div>
  }

  return (
    <div className="overflow-x-auto">
      <table className="table table-zebra w-full">
        <thead>
          <tr>
            <th>Artifact Name</th>
            <th>Published At</th>
            <th>Code Version</th>
            <th>Ingested At</th>
            <th>Upstream Version</th>
          </tr>
        </thead>
        <tbody>
          {versions.blastDbs?.map((v, index) => (
            <tr key={v.artifactName ?? index}>
              <td>{v.artifactName}</td>
              <td>{v.publishedAt ? formatDate(parseDate(v.publishedAt)) : 'N/A'}</td>
              <td>{v.codeVersion}</td>
              <td>{v.ingestedAt ? formatDate(parseDate(v.ingestedAt)) : 'N/A'}</td>
              <td>{v.upstreamVersion}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="flex justify-center p-2 text-sm">
        <div>Last checked at {versions.latestRun?.startedAt ? formatDate(parseDate(versions.latestRun?.startedAt)) : 'unknown'}</div>
      </div>
    </div>
  )
}
